import { landing_home,customer_stories } from "../../assets/images";
import styled from 'styled-components';

import CTASection from "../landing/landing_home/empower"
import Footer from "../Footer/footer"
import Navigation from "../navigation/header"
import Challenges from "./challenge";
import Solutions from "./solution";
import StudentAndStaffResults from "./students";
import { FaCloudArrowDown as CloudDownload } from "react-icons/fa6";


const Customer = () => {

const handleDownload = () => {
  const pdfUrl = "/docs/case-study.pdf"; // now accessible directly
  window.open(pdfUrl, "_blank"); // opens in new tab

  const link = document.createElement("a");
  link.href = pdfUrl;
  link.download = "Case Study for Campus Insights- CMN.pdf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  return (
    <>
      <Navigation />
      <HeroContainer>
        <ContentWrapper>
          <TextContent>
            <MainHeading>
              College of the Muscogee Nation <Highlight>(CMN)</Highlight>
            </MainHeading>
            <Subtitle>
              Empowering Students. Preserving Culture. Powered by Campus Insights from Sentellent
            </Subtitle>
          </TextContent>

          <CTAButton onClick={handleDownload}>
           Download Case Study
          </CTAButton>


        </ContentWrapper>
      </HeroContainer>
 <Challenges/>
 <Solutions/>
 <StudentAndStaffResults/>
      <CTASection />
      <Footer />
    </>
  );
};

const CTAButton = ({ children, ...props }) => {
  return (
    <ButtonContainer1 {...props}>
      <ButtonText1>{children}</ButtonText1>
      <IconWrapper>
        <CloudDownload color="#fff" />
      </IconWrapper>
    </ButtonContainer1>
  );
};



export default Customer;

const ButtonContainer1 = styled.button`
  display: flex;
  height: 48px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.7);
  background: #D92128;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;

  @media (max-width: 640px) {
    width: 100%;
    max-width: 240px;
  }
`;

const ButtonText1 = styled.span`
  color: #fff;
  text-align: center;
  letter-spacing: -0.075px;
  font: 700 15px/140% Inter, -apple-system, Roboto, Helvetica, sans-serif;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;

const HeroContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 430px;
  // width: 97%;
  overflow: hidden;
  position: relative;
  padding: 140px 20px 40px;

 background: 
    linear-gradient(
      rgba(0, 0, 0, 0.4) 0%,         /* Slight dark overlay at top */
      rgba(0, 0, 0, 0.55) 50%,       /* Medium at center */
      rgba(0, 0, 0, 0.75) 100%       /* Stronger at bottom */
    ),
    url(${customer_stories}) top center / cover no-repeat;

  background-blend-mode: normal;

  > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 640px) {
    padding: 20px 16px;
    height: 520px;
  }
`;


const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 989px;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  @media (max-width: 991px) {
    max-width: 700px;
    gap: 28px;
  }

  @media (max-width: 640px) {
    gap: 24px;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

const Highlight = styled.span`
  color: #D92128;
`;


const MainHeading = styled.h1`
  width: 100%;
  color: #fff;
  text-align: center;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: -0.6px;
  font: 700 60px/70px 'Inter', sans-serif;
  margin: 0;

  @media (max-width: 991px) {
    font-size: 48px;
    line-height: 56px;
  }

  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: -0.4px;
  }
`;

const Subtitle = styled.p`
  color: #fff;
  text-align: center;
  letter-spacing: -0.08px;
  font: 500 16px/160% 'Inter', sans-serif;
  margin: 0;

  @media (max-width: 640px) {
    font-size: 14px;
    line-height: 150%;
  }
`;

const ButtonContainer = styled.button`
  display: flex;
  height: 48px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.7);
  background: linear-gradient(90deg, #5ea1ff 0%, #6a37e3 56.38%);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;

  @media (max-width: 640px) {
    width: 100%;
    max-width: 280px;
  }
`;

const ButtonText = styled.span`
  color: #fff;
  text-align: center;
  letter-spacing: -0.075px;
  font: 600 15px/140% Inter, sans-serif;
`;